import { Ionicons } from '@expo/vector-icons';
import { ActivityIndicator, Image, Pressable, StyleSheet, View } from 'react-native';

import { BorderRadius, Spacing } from '@/constants/spacing';

interface ChatAttachmentPreviewProps {
  imageUri: string | null;       // display data URL (or file URI) for thumbnail
  isCompressing: boolean;
  onClear: () => void;
}

export function ChatAttachmentPreview({ imageUri, isCompressing, onClear }: ChatAttachmentPreviewProps) {
  if (!imageUri && !isCompressing) return null;

  return (
    <View style={styles.row}>
      <View style={styles.thumbWrapper}>
        {imageUri ? (
          <Image source={{ uri: imageUri }} style={styles.thumb} resizeMode="cover" />
        ) : (
          <View style={[styles.thumb, styles.placeholder]}>
            <ActivityIndicator size="small" />
          </View>
        )}
        <Pressable
          onPress={onClear}
          style={styles.removeButton}
          hitSlop={6}
          accessibilityLabel="Remove photo"
          accessibilityRole="button"
        >
          <Ionicons name="close" size={12} color="#FFFFFF" />
        </Pressable>
      </View>
    </View>
  );
}

const THUMB_SIZE = 56;

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    paddingHorizontal: Spacing.sm,
    paddingBottom: Spacing.xs,
  },
  thumbWrapper: {
    position: 'relative',
  },
  thumb: {
    width: THUMB_SIZE,
    height: THUMB_SIZE,
    borderRadius: BorderRadius.md,
    backgroundColor: 'rgba(0,0,0,0.08)',
  },
  placeholder: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  removeButton: {
    position: 'absolute',
    top: -6,
    right: -6,
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: 'rgba(0,0,0,0.7)',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
